<template>
  <el-select v-model="value" placeholder="请选择">
    <el-option label="全部流程" value="" />
    <el-option
      v-for="item in list"
      :key="item.key"
      :label="item.name"
      :value="item.key" />
  </el-select>
</template>

<script>
export default {
  props: {
    value: String,
    list: Array
  },
  watch: {
    value: {
      handler(val) {
        this.$emit('onSelect', val)
      },
      immediate: true
    }
  }
}
</script>
